import { Component, Input } from '@angular/core';

/**
 * Renders an optional row of small decorative "ribbons" (image assets) — typically
 * shown alongside a title in lists/cards. Mirrors the shape of `<rmt-labels>`:
 * the consumer supplies an array of typed items, the component knows how to map
 * each type to the right asset.
 *
 * Add a new ribbon type by:
 *   1. Extending `ribbonType` below.
 *   2. Adding the type → asset mapping in `getSrcFor()`.
 *   3. Optionally a width/height override if it has a non-default aspect ratio.
 */
@Component({
  selector: 'rmt-ribbons',
  templateUrl: 'rmt-ribbons.html'
})
export class RmtRibbonsComponent {

  @Input() ribbons: RibbonItem[];

  constructor() { }

  getSrcFor(ribbon: RibbonItem): string {
    switch (ribbon && ribbon.type) {
      case 'pay-by-bank':
        return 'assets/pay-by-bank/uk-banks-ribbon.svg';
      default:
        return '';
    }
  }
  
}

export type ribbonType = 'pay-by-bank';

export interface RibbonItem {
  type: ribbonType;
}



// WEBPACK FOOTER //
// ./src/components/rmt-ribbons/rmt-ribbons.ts